import { decryptObject } from '../../view/shared/utilities/cache';

export const findMemberName = (txMemberId, loadedMembers, localMembersCollection, cachedSecretary) => {
  let member = loadedMembers.find(m => m.id === txMemberId || m.pubkey === txMemberId);
  if (member) return member.full_name;
  const cachedMemberRequest = localMembersCollection.find(m => m.cacheId === txMemberId);
  if (cachedMemberRequest) {
    try {
      const decryptedString = decryptObject(cachedMemberRequest.encryptedBody, cachedMemberRequest.salt);
      const decryptedBody = JSON.parse(decryptedString);
      return decryptedBody.body?.data?.full_name;
    } catch (e) {
      return "Unknown Member";
    }
  }
  else if (cachedSecretary && (txMemberId === cachedSecretary.pubkey || txMemberId === cachedSecretary.id)) {
    return cachedSecretary.full_name
  }
  return "Unknown Member";
};
